import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as faEmptyStar } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-rating-selector',
  templateUrl: './rating-selector.component.html',
  styleUrls: ['./rating-selector.component.scss']
})
export class RatingSelectorComponent implements OnInit {
  @Input() maxRating: number = 5;
  @Input() currentRating: number = 5;
  @Output() setRating: EventEmitter<number> = new EventEmitter();

  rating: number = 5;
  tempRating: number = 5;

  starIcon = faStar;
  emptyStarIcon = faEmptyStar;

  constructor() { }

  ngOnInit(): void {
    this.rating = this.currentRating;
    this.tempRating = this.rating;
  }

  onMouseEnter(value: number): void {
    this.tempRating = value;
  }

  onMouseLeave(): void {
    this.tempRating = this.rating;
  }

  onClick(): void {
    this.rating = this.tempRating;
    this.setRating.emit(this.rating);
  }

}
